import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BeakerIcon, Factory, ClipboardListIcon, UsersIcon } from 'lucide-react';
import { useUser } from '../context/UserContext';
import { LoginDialog } from './LoginDialog';
import { UserManagement } from './UserManagement';
import { Footer } from './Footer';
export function ModuleSelection() {
  const {
    login,
    adminLogin
  } = useUser();
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [showUserManagement, setShowUserManagement] = useState(false);
  const [selectedPath, setSelectedPath] = useState('');
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const modules = [{
    id: 'production',
    name: 'Produktion',
    description: 'Produktionssteuerung und Überwachung',
    icon: <Factory className="w-8 h-8 mb-3 text-[#3498dd]" data-id="element-683" />,
    path: '/production',
    active: true
  }, {
    id: 'laboratory',
    name: 'Labor',
    description: 'Laboranalysen und Qualitätskontrolle',
    icon: <BeakerIcon className="w-8 h-8 mb-3 text-gray-400" data-id="element-684" />,
    path: '/laboratory',
    active: false
  }, {
    id: 'disposition',
    name: 'Disposition',
    description: 'Auftragsplanung und Logistik',
    icon: <ClipboardListIcon className="w-8 h-8 mb-3 text-gray-400" data-id="element-685" />,
    path: '/disposition',
    active: false
  }];
  const handleModuleClick = (path: string) => {
    setSelectedPath(path);
    setShowLoginDialog(true);
  };
  const handleLogin = async (username: string, password: string) => {
    const success = await login(username, password);
    if (success) {
      setShowLoginDialog(false);
      window.location.href = selectedPath;
    }
    return success;
  };
  const handleUserManagementClick = () => {
    setShowAdminLogin(true);
  };
  const handleAdminLogin = async (username: string, password: string) => {
    const success = await adminLogin(password);
    if (success) {
      setShowAdminLogin(false);
      setShowUserManagement(true);
    }
    return success;
  };
  return <div className="min-h-screen bg-gray-100 flex flex-col" data-id="element-686">
      <div className="flex-grow py-12 px-4 sm:px-6 lg:px-8" data-id="element-687">
        <div className="max-w-5xl mx-auto" data-id="element-688">
          <div className="flex justify-end mb-4" data-id="element-689">
            <button onClick={handleUserManagementClick} className="p-2 text-gray-600 hover:text-gray-800" data-id="element-690">
              <UsersIcon size={24} data-id="element-691" />
            </button>
          </div>
          <div className="text-center mb-12" data-id="element-692">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/n1Fswej3PBBSkNK23fqzm4/cirkel.png" alt="Cirkel Logo" className="h-32 mx-auto mb-12" data-id="element-693" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-694">
              Modulauswahl
            </h1>
            <p className="text-gray-500" data-id="element-695">Wählen Sie das gewünschte Modul aus</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-696">
            {modules.map(module => <div key={module.id} className={`bg-white rounded-lg shadow-sm p-6 text-center ${!module.active && 'opacity-50'}`} data-id="element-697">
                {module.icon}
                <h2 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-698">
                  {module.name}
                </h2>
                <p className="text-sm text-gray-500 mb-4" data-id="element-699">
                  {module.description}
                </p>
                {module.active ? <button onClick={() => handleModuleClick(module.path)} className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#3498dd] hover:bg-blue-600" data-id="element-700">
                    Öffnen
                  </button> : <button disabled className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-gray-500 bg-gray-100 cursor-not-allowed" data-id="element-701">
                    Demnächst verfügbar
                  </button>}
              </div>)}
          </div>
        </div>
      </div>
      <Footer data-id="element-702" />
      {showLoginDialog && <LoginDialog onClose={() => setShowLoginDialog(false)} onLogin={handleLogin} data-id="element-703" />}
      {showAdminLogin && <LoginDialog onClose={() => setShowAdminLogin(false)} onLogin={handleAdminLogin} data-id="element-704" />}
      {showUserManagement && <UserManagement onClose={() => setShowUserManagement(false)} data-id="element-705" />}
    </div>;
}